module.exports = __webpack_public_path__ + "img/voyzant_logo.306d8eca.png";